<template>
  <detail
    envName="生产环境"
    :envInfoType="3" />
</template>

<script>
import Detail from '@/components/business/traceinfo/detail'
export default {
  name: 'WorkEnvDetail',
  components: { Detail },
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {}
}
</script>
<style lang="stylus" scoped></style>
